import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { LoaderService } from "./loader.service";
import { CommonHttpService } from "../../components/commonHttp.service";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute } from "@angular/router";

@Injectable()
export class AddToCartService {
  baseUrl: any = environment.apiUrl;
  cart: any = {};
  EcartItem: any = [];
  cartItems: any = [];
  customerId: any;
  customerName: any;
  EcartGrandTotal: number = 0;
  EcartTotalTaxAmount: number = 0;
  EcartTotalCessAmount: number = 0;
  quantityFlag: number = 0;
  IsPhonepe: any;
  private cartChange = new BehaviorSubject<boolean>(false);
  isCartChanged = this.cartChange.asObservable();

  constructor(
    private service: CommonHttpService,
    private router: Router,
    private loaderService: LoaderService
  ) {
    this.IsPhonepe = false;
  }
  ngOnInit() {
    let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
    this.customerId = Number(localStorage.getItem("customerId"));
    this.customerName = Number(localStorage.getItem("customerName"));
    console.log(this.customerName);
    console.log(this.customerId);
    console.log(IsPhonepe);
  }

  addToCart(product) {
    this.quantityFlag = 0;
    this.customerId = Number(localStorage.getItem("customerId"));
    this.cart = JSON.parse(localStorage.getItem("cart"));
    if (this.cart != null) {
      for (let i = 0; i < this.cart.EcartItem.length; i++) {
        if (product.productId == this.cart.EcartItem[i].ProductId) {
          this.cart.EcartItem[i].Quantity = product.cartQuantity;
          this.cart.EcartItem[i].SubTotal =
            product.price * product.cartQuantity;
          this.quantityFlag = 1;
        }
      }
      if (this.quantityFlag == 0) {
        this.cart.EcartItem.push({
          EcartItemId: 0,
          EcartMasterId: 0,
          ProductId: product.productId,
          BatchId: product.batchId,
          Quantity: product.cartQuantity,
          TaxAmount: product.taxRates,
          CessTaxRate: product.cessTaxRates,
          Mrp: product.mrp,
          Price: product.price,
          SubTotal: product.price * product.cartQuantity,
          ProductImage: product.imageUrl,
          ProductName: product.productName,
          MaxStockLimit: product.totalStock,
        });
      }
    } else {
      this.cart = {};
      this.cart.EcartMasterId = 0;
      this.cart.EcartShippingAmount = 0;
      this.cart.EcartItem = [];
      this.cart.EcartItem.push({
        EcartItemId: 0,
        EcartMasterId: 0,
        ProductId: product.productId,
        BatchId: product.batchId,
        Quantity: product.cartQuantity,
        TaxAmount: product.taxRates,
        CessTaxRate: product.cessTaxRates,
        Mrp: product.mrp,
        Price: product.price,
        SubTotal: product.price * product.cartQuantity,
        ProductImage: product.imageUrl,
        ProductName: product.productName,
        MaxStockLimit: product.totalStock,
      });
    }
    this.sendCartDetails(2);
  }

  addToCartAfterCheckout() {
    this.customerId = Number(localStorage.getItem("customerId"));
    this.cart = JSON.parse(localStorage.getItem("cart"));
    console.log(this.cart);
    this.sendCartDetails(2);
  }
  getCartDetailsAfterLoginPhonepe() {
    console.log(this.IsPhonepe);
    this.IsPhonepe = true;
    this.getCartDetailsAfterLogin();
  }
  getCartDetailsAfterLogin() {
    this.customerId = Number(localStorage.getItem("customerId"));
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.service
      .get(this.baseUrl + "CartAPI/GetByUserId/" + this.customerId)
      .subscribe(
        (data) => {
          this.loaderService.display(false);
          console.log(data);
          if (data.length != 0) {
            this.cartItems = data != null ? data[0].ecartList : [];
          } else {
            this.cartItems = [];
          }

          if (this.cart != null) {
            for (var i = 0; i < this.cartItems.length; i++) {
              this.quantityFlag = 0;
              for (let j = 0; j < this.cart.EcartItem.length; j++) {
                if (
                  this.cartItems[i].productId ==
                  this.cart.EcartItem[j].ProductId
                ) {
                  this.cart.EcartItem[j].Quantity =
                    this.cart.EcartItem[j].Quantity +
                    this.cartItems[i].quantity;
                  this.cart.EcartItem[j].SubTotal =
                    this.cartItems[i].price * this.cart.EcartItem[j].Quantity;
                  this.quantityFlag = 1;
                }
              }
              if (this.quantityFlag == 0) {
                this.cart.EcartItem.push({
                  EcartItemId: 0,
                  EcartMasterId: 0,
                  ProductId: this.cartItems[i].productId,
                  BatchId: this.cartItems[i].batchId,
                  Quantity: this.cartItems[i].quantity,
                  TaxAmount: this.cartItems[i].taxRates,
                  CessTaxRate: this.cartItems[i].cessTaxRates,
                  Mrp: this.cartItems[i].mrp,
                  Price: this.cartItems[i].price,
                  SubTotal:
                    this.cartItems[i].price * this.cartItems[i].quantity,
                  ProductImage: this.cartItems[i].imageUrl,
                  ProductName: this.cartItems[i].productName,
                  MaxStockLimit: this.cartItems[i].totalStock,
                });
              }
            }
            this.sendCartDetails(1);
          } else {
            if (data != null) {
              this.cart = {};
              this.cart.EcartItem = [];
              for (var i = 0; i < this.cartItems.length; i++) {
                console.log(i);
                this.cart.EcartItem.push({
                  EcartItemId: 0,
                  EcartMasterId: 0,
                  ProductId: this.cartItems[i].productId,
                  BatchId: this.cartItems[i].batchId,
                  Quantity: this.cartItems[i].quantity,
                  TaxAmount: this.cartItems[i].taxRates,
                  CessTaxRate: this.cartItems[i].cessTaxRates,
                  Mrp: this.cartItems[i].mrp,
                  Price: this.cartItems[i].price,
                  SubTotal:
                    this.cartItems[i].price * this.cartItems[i].quantity,
                  ProductImage: this.cartItems[i].imageUrl,
                  ProductName: this.cartItems[i].productName,
                  MaxStockLimit: this.cartItems[i].totalStock,
                });
              }
              localStorage.setItem("cart", JSON.stringify(this.cart));
              console.log(this.cart);
            }
            this.router.navigate([""]);
            this.cartChange.next(true);
          }
        },
        (error) => { }
      );
  }

  sendCartDetails(status) {
    for (let i = 0; i < this.cart.EcartItem.length; i++) {
      this.EcartGrandTotal =
        this.EcartGrandTotal + this.cart.EcartItem[i].SubTotal;
      this.EcartTotalTaxAmount =
        this.EcartTotalTaxAmount + this.cart.EcartItem[i].TaxAmount;
      this.EcartTotalCessAmount =
        this.EcartTotalCessAmount + this.cart.EcartItem[i].CessTaxRate;
    }
    this.cart.EcartGrandTotal = this.EcartGrandTotal;
    this.cart.EcartTotalTaxAmount = this.EcartTotalTaxAmount;
    this.cart.EcartTotalCessAmount = this.EcartTotalCessAmount;
    localStorage.setItem("cart", JSON.stringify(this.cart));
    this.cartChange.next(true);
    if (localStorage.getItem("isLoggedin")) {
      this.loaderService.display(true);
      this.cart.EcustomerId = this.customerId;
      console.log("cart");
      console.log(this.cart);
      this.service
        .create(this.baseUrl + "CartAPI/AddCart", this.cart)
        .subscribe(
          (data) => {
            console.log(data);
            if (status == 1) {
              if (localStorage.getItem("isCartPage")) {
                this.loaderService.display(true);
                localStorage.removeItem("isCartPage");
                if (this.IsPhonepe == true) {
                  console.log("queryparams passed in phonepe");
                  this.router.navigate(["cart"], {
                    queryParams: { utm_source: "phonepe" },
                  });
                } else {
                  this.router.navigate(["cart"]);
                }
              } else {
                this.router.navigate([""]);
              }
            }
            this.loaderService.display(false);
          },
          (error) => {
            this.loaderService.display(false);
          }
        );
    }
  }

  logOut() {
    this.cartChange.next(true);
  }

  login() {
    this.cartChange.next(true);
  }

  removedFromCart() {
    this.cartChange.next(true);
    this.customerId = Number(localStorage.getItem("customerId"));
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.sendCartDetails(2);
  }
  deleteCart() {
    this.cartChange.next(true);
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/_shared/services/add-to-cart.service.ts